import React from 'react';
import { normalizarTexto } from './tiendaUtils';

export default function CampoTexto({ grupo, valor, onCambiar }) {
  return (
    <div className="rounded-2xl border border-[#27272A] bg-[#18181B] p-5">
      <input
        value={valor?.texto || ''}
        onChange={e => onCambiar({ ...valor, opcion_ids: [], texto: normalizarTexto(grupo, e.target.value) })}
        maxLength={grupo.max_caracteres}
        placeholder={grupo.mayusculas ? 'ABC'.slice(0, grupo.max_caracteres) : ''}
        autoCapitalize="characters"
        aria-label={grupo.nombre}
        className="w-full rounded-xl border border-[#27272A] bg-[#0A0A0A] px-4 py-4 text-center font-serif text-2xl uppercase tracking-[0.4em] text-white placeholder-zinc-700 outline-none transition-colors focus:border-[#C9A962]"
        data-testid={`grupo-texto-${grupo.id}`}
      />
      <p className="mt-2 text-center text-xs text-zinc-500">
        Máximo {grupo.max_caracteres} {grupo.solo_letras ? 'letras, sin números ni símbolos' : 'caracteres'}.
      </p>
    </div>
  );
}
